// Redux Actions for Analytics Profiles
export const SET_ANALYTICS_PROFILES = "SET_ANALYTICS_PROFILES";

export const setAnalyticsProfiles = (analyticsProfiles) => ({
  type: SET_ANALYTICS_PROFILES,
  payload: analyticsProfiles,
});
